import axiosRagflow from 'constants/axios';
import * as Status from 'containers/desktop/KnowledgeBases/types/Status';

export * as Document from 'containers/desktop/KnowledgeBases/types/Document';

export type Type = {
	id: string;
	name: string;
	create_date: string;
	type: string;
	status: Status.Type;
};

export function create(): Type {
	return {
		id: '',
		name: '',
		create_date: '',
		type: '',
		status: Status.Type.UNSTART,
	};
}

export async function deleteFromApi(obj: Type, knowledgeBaseId: string): Promise<void> {
	await axiosRagflow.delete(`/api/v1/datasets/${knowledgeBaseId}/documents`, {
		data: { ids: [obj.id] },
	});
}

export async function parseAtApi(obj: Type, knowledgeBaseId: string): Promise<Type> {
	await axiosRagflow.post(`/api/v1/datasets/${knowledgeBaseId}/chunks`, {
		document_ids: [obj.id],
	});
	return {
		...obj,
		status: Status.Type.RUNNING,
	};
}

export async function stopParsingAtApi(obj: Type, knowledgeBaseId: string): Promise<Type> {
	await axiosRagflow.delete(`/api/v1/datasets/${knowledgeBaseId}/chunks`, {
		data: { document_ids: [obj.id] },
	});
	return {
		...obj,
		status: Status.Type.UNSTART,
	};
}

export function mapFromApi(item: any): Type {
	return {
		id: item?.id ?? '',
		name: item?.name ?? '',
		create_date: item?.create_date ?? '',
		type: item?.type ?? '',
		status: item?.run ?? Status.Type.UNSTART,
	};
}
